import { useState } from "react";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { ContestRegistrationForm } from "./registration/ContestRegistrationForm";
import { SearchRegistration } from "./registration/SearchRegistration";

const ExprimeCharteInscription = () => {
  const [registrationId, setRegistrationId] = useState<string | undefined>();

  const handleRegistrationFound = (id: string) => {
    setRegistrationId(id);
  };

  const handleUpdate = () => {
    // Réinitialiser pour revenir au mode création
    setRegistrationId(undefined);
  };

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-grow relative pt-24 overflow-hidden">
        {/* Background with gradient and gavroche */}
        <div className="absolute inset-0 z-0">
          <div className="h-full w-full bg-gradient-to-br from-[#FFFF4D] via-[#FFE94B] to-[#A3D960]"></div>
          <div className="absolute top-0 right-0 h-full w-1/3 md:w-2/5 opacity-30 md:opacity-40 flex items-end">
            <img 
              src="/lovable-uploads/180f51c0-05cf-4dfd-b4b7-91b153baf486.png" 
              alt="Décoration" 
              className="h-auto w-full object-contain object-bottom drop-shadow-xl" 
            />
          </div>
        </div>
        
        <div className="container relative z-10 mx-auto px-4 py-8">
          <div className="max-w-4xl mx-auto">
            <h1 className="text-4xl font-bold text-center mb-4 text-[#001233] mt-12">
              Inscription au concours Exprime la Charte
            </h1>
            <p className="text-center text-[#001233]/80 mb-8">
              À compléter par l'établissement ou l'équipe pédagogique
            </p>
            
            <SearchRegistration onRegistrationFound={handleRegistrationFound} />
            
            <ContestRegistrationForm 
              registrationId={registrationId}
              onUpdate={handleUpdate}
            />
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default ExprimeCharteInscription;
